import checkIfBlockIsVisible from "./checkIfBlockIsVisible";
import evaluateOutputCalculation from "./evaluateOutputCalculation";
import { splitCode } from "@feature/kcolor/utils/utils";

const convertRecursiveRows = (
  list,
  blocks,
  getOptionTitle,
  context,
  recursiveQuestionId = null
) => {
  const { responses, configuration } = context;
  return list.map((rowResponses, idx) => {
    const totalResponses = { ...responses, ...rowResponses };
    return blocks.reduce((acc, block) => {
      let value = "";
      // define responses set to be used in order to evaluate block dependencies
      const responsesToCheck = { ...totalResponses };
      if (!!recursiveQuestionId)
        // if the current recursive question's id is provided, override its responses (which is a list of objects, one
        // for each row) with only the current row
        responsesToCheck[recursiveQuestionId] = [rowResponses];

      // determine block value for current row
      if (checkIfBlockIsVisible(
        block,
        {
          ...context,
          responses: responsesToCheck,
        },
        idx,
      )) {
        switch (block.type) {
          case "question":
            if (rowResponses[block.id]) {
              const option_type = ["select", "multi_select"].includes(
                block.input_type
              )
                ? block.input_type
                : false;
              if (option_type) {
                const opt_values =
                  option_type === "multi_select"
                    ? rowResponses[block.id].value
                    : [rowResponses[block.id].value];
                const questionOptions =
                  rowResponses[block.id].question?.options
                  || configuration.filter((b) => b.type === 'option' && b.input_id === block.id);
                value = opt_values.map((v) =>
                  getOptionTitle(questionOptions.find((o) => o.id === parseInt(v)))
                );
              } else {
                if (block.input_type === "k_color_input") {
                  value = `${rowResponses[block.id]?.value?.kColorProduct?.des_prod_comm || ''} ${splitCode(rowResponses[block.id]?.value?.color?.code || '')} ${rowResponses[block.id]?.value?.productPackage || ''} ${rowResponses[block.id]?.value?.kColorProduct?.base_um || ''}`;
                } else {
                  value = rowResponses[block.id].value;
                }
              }
            }
            break;
          case "alert": {
            value = true;
            break;
          }
          case "output": {
            switch (block.output_type) {
              case "calculation":
                value = evaluateOutputCalculation(
                  block,
                  {
                    ...context,
                    /*
                    Hubspot ticket 17147037978
                    using totalResponses instead of
                    rowResponses to evaluate calculation
                    breaks dependencies because of getFlattenedResponses
                    in a recursive question there were two different
                    answer for the same question and flattening them overwrote
                    one breaking a dependency when evaluating calculation
                    for products
                    Hubspot ticket 17285209179
                    using rowResponses instead of responsesToCheck
                    breaks dependencies because there maybe dependencies
                    outside of the recursive question row that need to be
                    evaluated
                     */
                    responses: responsesToCheck,
                  },
                  undefined,
                  idx,
                );
                break;
              case "question": {
                if (rowResponses[block.id]) {
                  value = rowResponses[block.id].option
                    ? getOptionTitle(rowResponses[block.id].option)
                    : rowResponses[block.id].value;
                }
                break;
              }
              default:
                value = block.title || block.name || "";
                break;
            }
            break;
          }

          default:
            break;
        }
      }

      return { ...acc, [block.id]: value };
    }, {});
  });
};

export default convertRecursiveRows;
